import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {DatePicker, Input, InputNumber} from "antd";
import NoPhotoImage from "../../assets/img/no-image.jpg";
import React, {useState, useEffect} from "react";
import ConsumerItem from "./ConsumerItem";
import dayjs from "dayjs";
import Button from "../element/Button";
import useAuth from "../../hooks/useAuth";

const CartItem = ({item, isMultiple, isValidate, onChangeItem, onChangeItemConsumers}) => {

    const { isAdminOrManagerOrPartner } = useAuth();

    const [quantity, setQuantity] = useState(0);
    const [total, setTotal] = useState(0);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [consumers, setConsumers] = useState([]);

    useEffect(() => {
        setQuantity(item.quantity);
        setConsumers(item.consumers);
        setDateFrom(item.fromDt);
        setDateTo(item.toDt);
    }, [])

    useEffect(() => {
        setTotal(item.price * quantity);
    }, [quantity])

   /* useEffect(() => {
        onChangeItemConsumers(item.id, consumers);
    }, [consumers])*/

    const normalizeQuantity = (value) => {
        const parsed = parseInt(value, 10);
        if (!Number.isFinite(parsed) || parsed < 1) {
            return 1;
        }
        return parsed;
    }

    const onChange = (qty) => {
        const nextQty = normalizeQuantity(qty);
        setQuantity(nextQty);
        onChangeItem(item.id, nextQty, dateFrom, dateTo);
    }
    const onValidate = (e) => {
        const nextQty = normalizeQuantity(e.target.value);
        e.target.value = nextQty;
        setQuantity(nextQty);
        onChangeItem(item.id, nextQty, dateFrom, dateTo);
    }

    const onQuantityKeyDown = (e) => {
        const allowedControlKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
        ];

        if (allowedControlKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
            return;
        }

        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const onQuantityPaste = (e) => {
        const pastedText = e.clipboardData.getData('text');
        if (!/^\d+$/.test(pastedText)) {
            e.preventDefault();
        }
    };

    const onRemove = () => {
        onChangeItem(item.id, 0);
    }

    const onChangeConsumer = (index, consumer) => {
        let tConsumers = [];
        [...Array(quantity).keys()].forEach((i) => {
            if (consumers[i] !== undefined) {
                if (i === index) {
                    tConsumers.push(consumer);
                } else {
                    tConsumers.push(consumers[i]);
                }
            } else {
                if (i === index) {
                    tConsumers.push(consumer);
                } else {
                    tConsumers.push({surname: '', name: '', phone: '', email: ''});
                }
            }
        })
        setConsumers(tConsumers);
        onChangeItemConsumers(item.id, tConsumers);
    }

    const onChangeDateFrom = (date, dateString) => {
        setDateFrom(dateString);
        onChangeItem(item.id, quantity, dateString, dateTo);
    };

    const onChangeDateTo = (date, dateString) => {
        setDateTo(dateString);
        onChangeItem(item.id, quantity, dateFrom, dateString);
    };

    return <div>
        <div className={'flex mob-flex-wrap items-center pb-4'}>
            <div className={'w-2/12 mob-w-full mob-m-4'}>
                <div className={'h-24 w-full rounded-lg object-cover object-center'} style={{
                    backgroundImage: 'url(' + (item.image ?? NoPhotoImage) + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                }}></div>
            </div>
            <div className={'pl-4 mob-pl-0 ' + (isMultiple ? 'w-4/12 mob-w-full' : 'w-7/12 mob-w-full')}>
                <div className={'font-bold'}>Код: {item.code}</div>
                <div className={''}>{item.name}</div>
            </div>
            <div className={'w-2/12 mob-w-4/12 text-center ml-auto mob-ml-0 mob-mt-4 mob-font-bold'}>
                {item.price} руб.
            </div>
            {
                isMultiple && <div className={'w-1/12 mob-w-3/12 text-center mob-mt-4'}>
                Кол-во:
                    <InputNumber
                        min={1}
                        defaultValue={quantity}
                        value={quantity}
                        onKeyUp={onValidate}
                        onKeyDown={onQuantityKeyDown}
                        onPaste={onQuantityPaste}
                        onChange={onChange}
                        className={'w-full text-center'}
                    />
                </div>
            }
            {
                isMultiple && <div className={'w-2/12 mob-w-4/12 text-center font-bold mob-mt-4'}>
                    {total} руб.
                </div>
            }
            <div className={'w-1/12 text-center ml-auto mob-mt-4'}>
                <button className={'text-error'} onClick={onRemove}>
                    <FontAwesomeIcon icon={faTrash}/>
                </button>
            </div>
        </div>
        {
            isMultiple > 0 && isAdminOrManagerOrPartner &&
            <div className={'w-full pb-4 mt-4'}>
                <div class={'desktop-hidden pb-2'}>Даты доступа:</div>
                <div className={'mb-4 flex gap-2 items-center'}>
                    <div class={'mob-hidden'}>Даты доступа:</div>
                    <DatePicker onChange={onChangeDateFrom}
                                value={dateFrom ? dayjs(dateFrom, 'DD.MM.YYYY') : ''}
                                placeholder={'от даты'} format={'DD.MM.YYYY'}/>
                    <div className={'ml-1 mr-1'}>-</div>
                    <DatePicker onChange={onChangeDateTo}
                                value={dateTo ? dayjs(dateTo, 'DD.MM.YYYY') : ''}
                                placeholder={'до даты'} format={'DD.MM.YYYY'}/>
                </div>
            </div>
        }
        {
            isMultiple && quantity > 0 &&
            <div className={'w-full pb-4'}>
                {
                    [...Array(quantity).keys()].map(i =>
                        <ConsumerItem onChangeConsumer={onChangeConsumer} validate={isValidate} consumer={consumers[i] !== undefined ? consumers[i] : null} key={i} i={i} />
                    )
                }
            </div>
        }
    </div>
}

export default CartItem;
